import React from "react";
import PropTypes from "prop-types";

import { OKAutosuggest } from "commonsComponents/OKAutosuggest";

import "./okNgoAutosuggest.scss";

const OkNgoAutosuggest = ({
  placeholderNgo,
  filteredCategoriesList,
  handleSelectedInAutosuggest,
  labelSearcherInput,
  noNgoFoundMessage
}) => {

  const renderNoSuggestion = <span>{noNgoFoundMessage}</span>;

  return (
      <div className="ok-ngo-input__wrapper">
          <p className="ok-ngo-input__label">{labelSearcherInput}</p>
          <OKAutosuggest
              dataset={filteredCategoriesList}
              maxItems="5"
              content="name"
              datasetKey="name"
              widthInput="small"
              format="text"
              uppercase
              placeholder={placeholderNgo}
              noSuggestionComponent={renderNoSuggestion}
              onSelect={suggestion => handleSelectedInAutosuggest(suggestion.suggestion)
        }
      />
      </div>
  );
};

OkNgoAutosuggest.propTypes = {
  value: PropTypes.string,
  filteredCategoriesList: PropTypes.array,
  onChange: PropTypes.func,
  placeholderNgo: PropTypes.string,
  noNgoFoundMessage: PropTypes.string,
  labelSearcherInput: PropTypes.string,
  handleSelectedInAutosuggest: PropTypes.func
};

export default OkNgoAutosuggest;
